import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CtrlBaseComponent } from '..';
import { breakpoints } from '../../environments/environment.breakpoints';

@Component({
  selector: 'ct-footer',
  templateUrl: './ct-footer.component.html',
  styleUrls: ['./ct-footer.component.css'],
  host: {
    '[id]': 'getId()'
}
})
export class CtFooterComponent extends CtrlBaseComponent implements OnInit, AfterViewInit {
  
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;


    //util
    public isMediumSize : boolean = false;
    public isSmallSize : boolean = false;
    public isExtraSmall : boolean = false;

    private isDesktop: boolean;

    

    @HostListener('window:resize', ['$event'])
    onResize() {
      this.manageWindowResizing(window.innerWidth);
    }

    constructor() { 
      super();
    }

    ngOnInit(): void {
      super.ngOnInit();
    }
  
    ngAfterViewInit(): void {
      this.manageWindowResizing(window.innerWidth);
      this.paintChildren(this.getMetaData(), this.target);
    } 
    

    private manageWindowResizing(width: number) {  
      this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
      this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
      this.isMediumSize = width >= breakpoints.L;
   
    }  
}



